import { Box, Typography } from "@mui/material";

import {
  STATEMENT_OF_PROFICIENCY_VALUES,
  StatementOfProficiencyValues,
} from "api/memberPortal/proficiencyFeedback/proficiencyFeedback.types";
import { withForm } from "components/Forms/AppForm";

import { defaultProficiencyFeedbackValues } from "../../../ProficiencyFeedbackForm.default";
import { ProficiencyFeedbackFormField } from "../../../ProficiencyFeedbackForm.schema";

const { SATISFACTORY, SATISFACTORY_COMMENTS, UNSATISFACTORY } =
  STATEMENT_OF_PROFICIENCY_VALUES;

const STATEMENT_OPTIONS = [
  {
    label:
      "The CCTL has satisfactorily completed the evaluation or it has been withdrawn. No comments or potential non-conformities are reported.",
    value: SATISFACTORY,
  },
  {
    label:
      "The CCTL has satisfactorily completed the evaluation. Comments or potential non-conformities are being reported. All potential, technical and management non-conformities were resolved sufficiently to complete the evaluation. (NVLAP follow-up with the CCTL may be requested, if non-conformities are reported, NVLAP follow-up is required)",
    value: SATISFACTORY_COMMENTS,
  },
  {
    label:
      "The CCTL has failed to satisfactorily complete the evaluation. Potential non-Conformities and any additional comments are reported below. (NVLAP follow-up with the CCTL is required)",
    value: UNSATISFACTORY,
  },
];

const CHECKBOX_FOLLOW_UP: Record<
  StatementOfProficiencyValues,
  { name: ProficiencyFeedbackFormField | ""; label: string; show: boolean }
> = {
  "": {
    name: "",
    label: "",
    show: false,
  },
  [SATISFACTORY]: {
    name: "",
    label: "",
    show: false,
  },
  [SATISFACTORY_COMMENTS]: {
    name: "requestedNvlapFollowUp",
    label: "Was NVLAP follow-up requested/required?",
    show: true,
  },
  [UNSATISFACTORY]: {
    name: "nvlapFollowUp",
    label: "NVLAP follow-up required?",
    show: true,
  },
} as const;

const StatementOfProficiencyFormSelect = withForm({
  defaultValues: defaultProficiencyFeedbackValues,
  props: { readonly: false },
  render: ({ form, readonly }) => {
    return (
      <>
        <form.AppField
          name="statementOfProficiency"
          listeners={{
            onChange: () => {
              form.setFieldValue("requestedNvlapFollowUp", false);
              form.setFieldValue("nvlapFollowUp", false);
            },
          }}
        >
          {(field) => (
            <field.RadioButton
              label={"Statement of Proficiency"}
              isHorizontal
              required={true}
              options={STATEMENT_OPTIONS}
              disabled={readonly}
            />
          )}
        </form.AppField>

        <form.Subscribe
          selector={(state) => {
            const value = state.values
              .statementOfProficiency as StatementOfProficiencyValues;

            return CHECKBOX_FOLLOW_UP[value];
          }}
        >
          {({ name, label, show }) => {
            if (!show || name === "") return;

            return (
              <Box sx={{ ml: 4, mt: 1 }}>
                <Typography>Additional Question:</Typography>
                <form.AppField name={name}>
                  {(field) => (
                    <field.SingleCheckbox label={label} disabled={readonly} />
                  )}
                </form.AppField>
              </Box>
            );
          }}
        </form.Subscribe>
      </>
    );
  },
});

export default StatementOfProficiencyFormSelect;
